import React from 'react';
import Dropzone from 'react-dropzone';

import { containsExt, arrayToString, bytesToSize } from '../../../helpers/string';

import '../forms.css';
import './file.css';
import FormLabel from '../formLabel';

export class File extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			uploaded: false,
			value: props.value,
			preview: '',
			localSrc: '',
			errorMsg: '',
			fileName: props.value ? props.value.name : '',
		};

		this.onDrop = this.onDrop.bind(this);
		this.remove = this.remove.bind(this);
	}

	reject() {
		this.setState({
			errorMsg: 'This is not a valid file',
		});
	}

	remove() {
		if (typeof this.props.onChange === 'function') {
			this.props.onChange('');
		}

		this.setState({ uploaded: false, value: null });
	}

	onDrop(files) {
		const { extensions, config } = this.props;
		let errorMsg = '';
		const maxSize = this.props.maxSize ? this.props.maxSize : config.MAX_ATTACHMENT_SIZE;

		if (extensions && !containsExt(files[0].name, extensions)) {
			errorMsg = `Sorry, but you must upload a file with an extension of ${arrayToString(extensions, ',', 'or')}`;
		}

		if (!errorMsg && files[0].size > maxSize) {
			errorMsg = `Sorry, but this file is too large (max. ${bytesToSize(maxSize)}).`;
		}

		if (errorMsg) {
			this.setState({
				uploaded: false,
				errorMsg,
				fileName: '',
			});
		} else {
			if (typeof this.props.onChange === 'function') {
				this.props.onChange(files[0]);
			}

			this.setState({
				uploaded: true,
				errorMsg: '',
				fileName: files[0].name,
			});
		}
	}

	render() {
		const { label, help, id, error, config, readonly, hideUploaded } = this.props;
		const { uploaded, errorMsg, value, fileName } = this.state;

		const maxSize = this.props.maxSize ? this.props.maxSize : config.MAX_ATTACHMENT_SIZE;

		return (
			<div key={id} id={id} className={`form-group ${errorMsg || error ? 'has-error' : ''}`}>
				<FormLabel {...this.props} htmlFor="file-upload-dropzone" />
				<div>
					{readonly ? null : (
						<div className="dropzone-container">
							<Dropzone
								id="file-upload-dropzone"
								onDrop={files => this.onDrop(files)}
								multiple={false}
								onDropRejected={this.reject}
								className="dropzone"
								activeClassName="active-dropzone"
							/>
							{!uploaded && !errorMsg && (
								<div className="dropzone-help">
									<div className="hidden-xs">
										Upload a document by dragging a file into, or clicking on this box
										<br />
										(Max file size: {bytesToSize(maxSize)})
									</div>
									<div className="hidden visible-xs">
										<i className="fa fa-file" />
									</div>
								</div>
							)}
							{!uploaded && errorMsg && (
								<div className="dropzone-help">
									<div className="flex flex-center-center text-red">
										<i className="fa fa-warning mb10" />
									</div>
								</div>
							)}
							{uploaded && (
								<div className="dropzone-help">
									<div className="hidden-xs">You have uploaded the document {fileName}.</div>
									<div className="hidden visible-xs">
										<i className="fa fa-check text-green" />
									</div>
								</div>
							)}
						</div>
					)}
					{(value || uploaded) && !hideUploaded && (
						<div className="mt10 ml10">
							<span className="uploaded-files mb10 mt10 flex flex-center">
								<i className="fa fa-check text-green mr10" />
								<span>{fileName ? fileName : 'File uploaded'}</span>
								{!readonly && (
									<i
										title="Delete"
										onClick={() => this.remove()}
										className="ml5 pointer text-danger fa fa-trash"
									/>
								)}
							</span>
						</div>
					)}
				</div>
				{(errorMsg || error) && <span className="help-block">{errorMsg || error}</span>}
			</div>
		);
	}
}

export default File;
